import * as React from 'react';
import { RefMap } from '../types';
import { isElementInViewport } from '../utils';

/**
 * Hook to detect which element is in view when scrolling
 * @returns the current item in view and function to set active item
 */
export const useScrollToActive = (refMap: RefMap) => {
  const [activeItem, setActiveItem] = React.useState(
    refMap.keys().next().value,
  );
  const setActiveElementOnScroll = React.useCallback(() => {
    for (const [name, ref] of refMap) {
      if (ref?.current && isElementInViewport(ref.current)) {
        setActiveItem(name);
        break;
      }
    }
  }, [refMap, setActiveItem]);

  React.useEffect(() => {
    window.addEventListener('scroll', setActiveElementOnScroll);
    return () => window.removeEventListener('scroll', setActiveElementOnScroll);
  }, [setActiveElementOnScroll]);

  return { activeItem, setActiveItem };
};
